<div class="items__select-area">
    <div
        class="wrapper-items__select-area"
        #selectCheckItem
        (click)="itemSelected()"
        (keydown.enter)="itemSelected()"
        (keydown.space)="itemSelected()"
        (keydown.arrowleft)="movedLeft()"
        (keydown.arrowright)="movedRight()"
        (keydown.arrowup)="movedLeft()"
        (keydown.arrowdown)="movedRight()"
        (focus)="focused()"
        (blur)="blurred()"
        role="radio"
        tabindex="{{ tabIndex }}"
        attr.aria-checked="{{ selected }}">
        <div class="btn btn--selection" [ngClass]="{ selected: selected }">
            <div class="circle-icon">
                <span class="icon icon-progress-check hidden"></span>
            </div>

            <div class="items__img" *ngIf="itemImage">
                <img class="dark:filter-yellow" [src]="customImageUrl || 'assets/item-image.png'" alt="" />
            </div>

            <span *ngIf="plainStringItem">{{ item | translate }}</span>
            <span *ngIf="!plainStringItem && locale && item.translations">{{ getItemTranslation() }}</span>
            <span *ngIf="!plainStringItem && locale && !item.translations">{{ item.display | translate }}</span>
            <span *ngIf="!plainStringItem && !locale">{{
                item.display ? item.display : item.name ? item.name : '-'
            }}</span>
        </div>
    </div>
</div>
